import axios from 'axios';
import { ResponseWithError } from '../models/app';

export const login = async ({
  email,
  password,
  session_token
}: {
  email: string;
  password: string;
  session_token: string;
}): Promise<ResponseWithError> => {
  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/user/login`;

  const body = new FormData();
  body.append('username', email);
  body.append('password', password);
  body.append('session_token', session_token);

  try {
    const response = await axios.post(url, body);

    if (response instanceof Error) {
      return { error: response };
    }

    if (response.data.error) {
      return { error: response.data };
    }

    return response;
  } catch (error) {
    return { error };
  }
};
